<template>
    <div class="pot-distribution">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-distribution</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Lönekostnad inklusive nytt löneutrymme
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-salary-sum></pot-salary-sum>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Nya värden, Grundlön
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-base-salary></pot-base-salary> 
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Nya värden, Befattningslön
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-position-salary></pot-position-salary> 
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Nya värden, Individuell lön
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-individual-salary></pot-individual-salary> 
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Analys
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-analysis></pot-analysis>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel class='theme-blue'>
                            <v-expansion-panel-title class="tab-title">
                                Överför
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div>
                                    <pot-transfer></pot-transfer>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PotAnalysis from './pot-analysis.vue'
    import PotBaseSalary from './pot-base-salary.vue'
    import PotIndividualSalary from './pot-individual-salary.vue'
    import PotPositionSalary from './pot-position-salary.vue'
    import PotSalarySum from './pot-salary-sum.vue'
    import PotTransfer from './pot-transfer.vue'

    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'pot-distribution',
        components: {
            PotAnalysis,
            PotBaseSalary,
            PotIndividualSalary,
            PotPositionSalary,
            PotSalarySum,
            PotTransfer
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
           }
        },
        data() {
            return {
                
            };
        },
        watch: {
            
        },
        mounted() {
           
            
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .theme-blue .v-expansion-panel-title {
        background-color: #4B6FB2 !important;
        color: white !important;
    }

    .theme-blue .v-expansion-panel-text {
        background-color: #c5d0ea !important;
    }

</style>
